<template>
  <div>
    <sideBar v-on:toggleCollapse="toggleCollapse"></sideBar>
    <div
      class="main"
      v-bind:class="{ bigMain: isCollapse }"
    >
      <router-view/>
    </div>
  </div>
</template>

<script>
import SideBar from '../components/SideBar.vue'
// import '@/openSurvey/theme/laydate.css'


export default {
  name: 'Main',
  components: {
    sideBar: SideBar
  },
  data () {
    return {
      isCollapse: false
    }
  },
  methods: {
    toggleCollapse: function () {
      this.isCollapse = !this.isCollapse
    }
  }
}
</script>

<style>

.main {
  margin: 0;
  padding: 0;
  margin-left: 260px;
  min-width: 1190px;
  transition: margin 0.5s
}
.main.bigMain {
  margin-left: 66px;
}
</style>



// WEBPACK FOOTER //
// src/openSurvey/pages/Main.vue